import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'

export function formatTimeDuration(time1: Date, time2: Date): string {
  dayjs.extend(duration)
  const diff = dayjs(time1).diff(dayjs(time2))
  const hours = Math.floor(dayjs.duration(diff).asHours())
  return hours + ':' + dayjs.duration(diff).format('mm:ss')
}
export function formatTimeFromNow(time: Date): string {
  dayjs.extend(relativeTime)
  return dayjs(time).fromNow()
}
